export default {
    mutations: {
        SET_MONITOR: "setMonitor",
        SET_LAST_CONNECTED_TIME: "setLastConnectedTime",
        SET_IS_EMERGENCY_MODE: "setIsEmergencyMode",
        SET_TIMER_FOR_IS_EMERGENCY_MODE: "setTimerForIsEmergencyMode",
        SET_IS_ONLINE: "setIsOnline",
    },
    actions: {
        SETUP: "setup",
        LOOP: "loop",
        CONNECTED: "connected",
        DISCONNECTED: "disconnected",
        SEND_ALERT: "sendAlert",
    },
    place: {
        mutations: {
            SET_PLACE_ID_HASH_LIST: "setPlaceIdhashList",
            SET_DISPLAY_VACANCY_LIST: "setDisplayVacancyList",
            SET_FETCHING_PLACE_TIMER: "setFetchingPlaceTimer",
            SET_FETCHING_VACANCY_TIMER: "setFetchingVacancyTimer",
            SET_FLOOR_PLAN: 'setFloorPlan',
            SET_AREA_GENDER:'setAreaGender',
        },
        actions: {
            SETUP: "setup",
            LOOP: "loop",
            TEARDOWN: "teardown",
        },
    },
};
